import React, {useCallback, useMemo, useState} from 'react';
import {
	funcDecodeHex24ToDocId,
	funcDecodeHex24ToEntity,
	InfinityListView,
} from 'components/InfinityList';
import {useTranslation} from 'react-i18next';
import {useUserContext} from 'authentication/UserContext';

export type IReportsPageViews = {
	(): InfinityListView[];
};

export const useReportsPageViews: IReportsPageViews = () => {
	const {favoriteIds} = useUserContext();
	const {t: tViews} = useTranslation('features/reports', {
		keyPrefix: 'Views',
	});

	const {t: tFav} = useTranslation('appShell/sidenavigation', {
		keyPrefix: 'SideNavigation',
	});

	const views: InfinityListView[] = useMemo(() => {
		const today = new Date();
		const date30 = new Date(new Date().setDate(today.getDate() - 30));
		const date90 = new Date(new Date().setDate(today.getDate() - 90));

		const viewsTemp = [
			{headerText: tViews('STD'), accessKey: 'STD', query: ''},
			{
				headerText: tViews('CHNG30'),
				accessKey: 'CHNG30',
				query: `{modifiedAt: { $gte : ISODate('${date30.toISOString()}') } }`,
			},
			{
				headerText: tViews('CHNG90'),
				accessKey: 'CHNG90',
				query: `{modifiedAt: { $gte : ISODate('${date90.toISOString()}') } }`,
			},
		];
		if (favoriteIds) {
			const favoriteRegIds = Object.keys(favoriteIds).filter(
				x => funcDecodeHex24ToEntity(x) === 'Regulation',
			);

			const favoriteRegDocIds = Object.keys(favoriteIds).filter(
				x => funcDecodeHex24ToEntity(x) === 'RegulatoryDocument',
			);
			if (favoriteRegIds.length > 0 || favoriteRegDocIds.length > 0) {
				const queryRegIds = favoriteRegIds
					.map(x => `'${funcDecodeHex24ToDocId(x)}'`)
					.join(',');
				const queryRegDocIds = favoriteRegDocIds
					.map(x => `ObjectId('${funcDecodeHex24ToDocId(x)}')`)
					.join(',');

				let queryviewFinal = `{}`;
				if (favoriteRegIds.length === 0 && favoriteRegDocIds.length > 0) {
					queryviewFinal = `{_id:{$in:[${queryRegDocIds}]}}`;
				}
				if (favoriteRegIds.length > 0 && favoriteRegDocIds.length === 0) {
					queryviewFinal = `{'regulationRef._id':{$in:[${queryRegIds}]}}`;
				}
				if (favoriteRegIds.length > 0 && favoriteRegDocIds.length > 0) {
					const query1 = `{'regulationRef._id':{$in:[${queryRegIds}]}}`;
					const query2 = `{_id:{$in:[${queryRegDocIds}]}}`;
					queryviewFinal = `{$or: [ ${query1}, ${query2}]}`;
				}

				viewsTemp.push({
					headerText: tFav('Favorites'),
					accessKey: 'FAV',
					query: queryviewFinal,
				});
			}
		}
		return viewsTemp;
	}, [favoriteIds]);

	return views;
};
